module.exports = __webpack_public_path__ + "static/media/SPG_QR.758eb587.svg";